// Единое правило поиска по всему сервису.
// Запрос делится на слова; строка подходит, если КАЖДОЕ слово встречается (целиком или частью)
// хотя бы в одном из её полей. Регистр и «ё/е» не важны. Пустой запрос подходит всему.
// Серверный аналог: backend/app/utils/search.py — правило должно совпадать.

export const normalizeSearchText = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/ | /g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const searchTokens = (query) => normalizeSearchText(query).split(' ').filter(Boolean);

// Все значения объекта/массива одной строкой (примитивы, вложенность до depth уровней).
export function collectSearchText(value, depth = 3) {
  if (value == null) return '';
  const type = typeof value;
  if (type === 'string' || type === 'number' || type === 'boolean') return String(value);
  if (depth <= 0) return '';
  if (Array.isArray(value)) return value.map((item) => collectSearchText(item, depth - 1)).join(' ');
  if (type === 'object') return Object.values(value).map((item) => collectSearchText(item, depth - 1)).join(' ');
  return '';
}

// fields: список имён полей или функций (item) => значение. Без fields ищем по всем полям.
// Текст строки без fields не меняется между нажатиями клавиш — запоминаем его для объекта.
const haystackCache = new WeakMap();

export function matchesSearch(item, query, fields) {
  const tokens = Array.isArray(query) ? query : searchTokens(query);
  if (!tokens.length) return true;
  let haystack;
  if (!fields && item && typeof item === 'object') {
    haystack = haystackCache.get(item);
    if (haystack === undefined) {
      haystack = normalizeSearchText(collectSearchText(item));
      haystackCache.set(item, haystack);
    }
  } else {
    const raw = fields
      ? fields.map((field) => collectSearchText(typeof field === 'function' ? field(item) : item?.[field])).join(' ')
      : collectSearchText(item);
    haystack = normalizeSearchText(raw);
  }
  return tokens.every((token) => haystack.includes(token));
}

// Готовый предикат для .filter(): items.filter(searchFilter(query, ['offer_id', 'name']))
export function searchFilter(query, fields) {
  const tokens = searchTokens(query);
  return (item) => matchesSearch(item, tokens, fields);
}

export function filterBySearch(items, query, fields) {
  const tokens = searchTokens(query);
  if (!tokens.length) return items;
  return (items || []).filter((item) => matchesSearch(item, tokens, fields));
}
